import React, {Component} from "react";
import {connect} from 'react-redux';
import FJToolbarCommon from "../view/FJToolbarCommon";
import classNames from "classnames";
import FJColorContainer from "../view/FJColorContainer";
import {FJDocumentColorAction, FJToolbarAction} from "../../../redux/action/FJRoot.action";
import FJLocalStore from "../../../store/FJLocalStore";
import FJResourceAction from "../../../redux/action/FJResource.action";
import FJViewConstant from "../../../constant/FJViewConstant";
import FJSlotButtonGroup from "../view/FJSlotButtonGroup";
import FJToolbarDevider from "../view/FJToolbarDevider";
import FJTransform from "../view/FJTransform";
import FJTransparency from "../view/FJTransparency";

class FJToolbarStaticSvgContainer extends Component {

  /**
   * @description 切换入场插槽
   */
  toggleIntroPanel = () => {
    let {showType, lastType, updateShowType} = this.props;
    let {RESOURCES_ANIMATION_INTRO} = FJViewConstant;
    if (showType === RESOURCES_ANIMATION_INTRO) {
      updateShowType(lastType);
    } else {
      updateShowType(RESOURCES_ANIMATION_INTRO);
    }
  };

  /**
   * @description 切换出场插槽
   */
  toggleOutroPanel = () => {
    let {showType, lastType, updateShowType} = this.props;
    let {RESOURCES_ANIMATION_OUTRO} = FJViewConstant;
    if (showType === RESOURCES_ANIMATION_OUTRO) {
      updateShowType(lastType);
    } else {
      updateShowType(RESOURCES_ANIMATION_OUTRO);
    }
  };

  /**
   * @description 静态svg颜色设置
   * @param type
   * @param color
   * @param index
   * @private
   */
  svgColorChanged = (type, color, index) => {
    let {colors, svgColorChanged} = this.props;
    let newColors = [...colors];
    newColors.splice(index, 1, color.mainColor);
    svgColorChanged(type, newColors);
  };

  render() {
    let containerClass = classNames('c-toolbar-text', {active: this.props.active});

    const {
      documentColors,
      addDocumentColor,
      deleteColor,
      disabled,
      colors,
			showType,
			opacityValue,
			opacityChange
    } = this.props;

    return (
      <FJToolbarCommon className={containerClass}>
        {
          colors.map((color, index) => {
            return (<FJColorContainer hasApplyToAll={false}
                                      useAnchorBody
                                      isTopLayer
                                      disabled={disabled}
                                      documentColors={documentColors}
                                      addDocumentColor={addDocumentColor}
                                      deleteColor={deleteColor}
                                      isSolid={true}
                                      colorData={{mainColor: color}}
                                      colorDataChange={(type, color) => {
                                        this.svgColorChanged(type, color, index)
                                      }}
                                      tips={FJLocalStore._('shape-color')}
                                      key={index}
            />);
          })
        }
				<FJToolbarDevider />
        <FJTransform type='element' />
				<FJToolbarDevider/>
				<FJTransparency opacityValue={opacityValue}
												opacityChange={opacityChange}
				/>
				<FJToolbarDevider />
        <FJSlotButtonGroup showType={showType}
                           toggleOutroPanel={this.toggleOutroPanel}
                           toggleIntroPanel={this.toggleIntroPanel} />
      </FJToolbarCommon>
    )
  }
}

const mapStateToProps = function (state) {
  return {
		showType: state.resource.showType,
    lastType: state.resource.lastType,
    documentColors: state.documentColor.documentColors,
    colors: state.toolSvg.colors,
		opacityValue: state.toolbar.opacityValue
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    svgColorChanged: function (type, colorData) {
      dispatch(FJToolbarAction.setSvgColorAction(type, colorData));
    },
    updateShowType: function (type) {
      dispatch(FJResourceAction.setShowTypeAction(type, undefined, true));
    },
    addDocumentColor: function (type, color) {
      dispatch(FJDocumentColorAction.addDocumentColorAction(type, color));
    },
    deleteColor: function (type, index) {
      dispatch(FJDocumentColorAction.deleteDocumentColorAction(type, index));
    },
		opacityChange: function (type, value) {
			dispatch(FJToolbarAction.changeOpacityValueAction(type, value))
		}
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FJToolbarStaticSvgContainer);